package com.elan.edubridge.ui.staff

import com.elan.edubridge.ui.shell.escapeHtml
import com.elan.edubridge.ui.shell.icon
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLElement

/**
 * 토스트(가이드 §4.1·§4.3). `#app-root` 밖 `document.body`에 직접 붙는다 — 라우트 전환 시
 * `renderPage()`가 `#app-root`의 innerHTML을 통째로 갈아치우므로, 그 안에 두면 토스트가 뜬 채로
 * 사용자가 다른 화면으로 이동할 때 같이 사라져 버린다.
 */
object Toast {
    fun success(message: String) = show(message, "success", "icon-check")

    fun error(message: String) = show(message, "error", "icon-warning")

    private fun show(message: String, variant: String, iconId: String) {
        val body = document.body ?: return
        val el = document.createElement("div") as HTMLElement
        el.className = "eb-toast eb-toast--$variant"
        el.setAttribute("role", "status")
        el.innerHTML = """
            ${icon(iconId, "md")}
            <span>${message.escapeHtml()}</span>
            <button class="eb-toast__close" aria-label="알림 닫기">${icon("icon-close", "sm")}</button>
        """.trimIndent()
        body.appendChild(el)

        (el.querySelector(".eb-toast__close") as? HTMLElement)?.onclick = {
            el.remove()
            null
        }
        window.setTimeout({ el.remove() }, 4000)
    }
}
